import logo from "../images/Green@small-bold.png";
import { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useLogin } from "../../hooks/useLogin";
import SimpleProductCard from "./SimpleProductCard";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronLeft,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [recentProducts, setRecentProducts] = useState([]);
  const [isLoadingProducts, setIsLoadingProducts] = useState(true);
  const [currentProductIndex, setCurrentProductIndex] = useState(0);

  const navigate = useNavigate();
  const { error, login } = useLogin();

  useEffect(() => {
    const fetchRecentProducts = async () => {
      try {
        setIsLoadingProducts(true);
        let url = "/api/products/recent?limit=10";

        if (process.env.NODE_ENV === "development") {
          url = `${process.env.REACT_APP_NETWORK}${url}`;
        }

        const response = await fetch(url);
        if (!response.ok) {
          throw new Error("Failed to fetch recent products");
        }

        const data = await response.json();
        setRecentProducts(data);
      } catch (err) {
        console.error("Error fetching recent products:", err);
      } finally {
        setIsLoadingProducts(false);
      }
    };

    fetchRecentProducts();
  }, []);

  const handlePrevProduct = () => {
    setCurrentProductIndex((prev) =>
      prev === 0 ? recentProducts.length - 1 : prev - 1
    );
  };

  const handleNextProduct = () => {
    setCurrentProductIndex((prev) =>
      prev === recentProducts.length - 1 ? 0 : prev + 1
    );
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    login(email.toLowerCase(), password);
  };

  return (
    <div className="login grid">
      <img src={logo} alt="" className="logo" />
      <h3>Buy More. Spend Less.</h3>
      <form onSubmit={handleSubmit}>
        <input
          type="email"
          onChange={(e) => setEmail(e.target.value)}
          value={email}
          placeholder="Email"
          autoComplete="on"
        />
        <input
          type="password"
          onChange={(e) => setPassword(e.target.value)}
          value={password}
          placeholder="Password"
          autoComplete="on"
        />
        <button className="login-button">Log In</button>
        <button onClick={() => navigate("/signup")}> Sign Up</button>
        {error && <p className="login-error">{error}</p>}
        <p className="signup-note">
          {<Link to="/login/reset-password">Forgot your password?</Link>}{" "}
        </p>
      </form>
      {!isLoadingProducts && recentProducts.length > 0 && (
        <div className="login-products-section">
          <h3 className="login-products-title">New Arrivals</h3>
          <div className="login-single-product-carousel">
            <button
              className="login-carousel-arrow login-carousel-arrow-left"
              onClick={handlePrevProduct}
              aria-label="Previous product"
            >
              <FontAwesomeIcon icon={faChevronLeft} />
            </button>
            <div className="login-product-display">
              <SimpleProductCard item={recentProducts[currentProductIndex]} />
              <div className="login-carousel-counter">
                {currentProductIndex + 1} of {recentProducts.length}
              </div>
            </div>
            <button
              className="login-carousel-arrow login-carousel-arrow-right"
              onClick={handleNextProduct}
              aria-label="Next product"
            >
              <FontAwesomeIcon icon={faChevronRight} />
            </button>
          </div>
        </div>
      )}
      <p className="login-serving-parsons">
        Serving Parsons, Kansas and Surrounding Communities
      </p>
      <div className="login-benefits-flex">
        <p className="login-benefits-child">No Minimum Order</p>
        <p className="login-benefits-child">Low Prices</p>
        <p className="login-benefits-child">No Membership Fees</p>
      </div>
    </div>
  );
};

export default Login;
